module.exports = __webpack_public_path__ + "img/wave-bottom.5996894d.svg";